module.exports = __webpack_public_path__ + "img/105.c0330e8e.svg";